import { AffineErrorBoundary } from '@affine/core/components/affine/affine-error-boundary';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import { Suspense } from 'react';

import { SettingsEntityMessage } from '../shared/settings-entity';
import { FoldersSettingsPanel } from './folders-panel';

interface WorkspaceSettingFoldersProps {
  onCloseSetting?: () => void;
}

export const WorkspaceSettingFolders = ({
  onCloseSetting: _onCloseSetting,
}: WorkspaceSettingFoldersProps) => {
  const t = useI18n();
  const workspaceService = useService(WorkspaceService);
  const isLocalWorkspace = workspaceService.workspace.flavour === 'local';

  if (isLocalWorkspace) {
    return (
      <SettingsEntityMessage>
        {t['com.streamlain.settings.workspace.permissions.local-only']?.() ??
          'Permissions are only available for cloud workspaces.'}
      </SettingsEntityMessage>
    );
  }

  return (
    <AffineErrorBoundary>
      <Suspense
        fallback={
          <SettingsEntityMessage>
            {t['com.streamlain.settings.workspace.permissions.loading']?.() ??
              'Loading...'}
          </SettingsEntityMessage>
        }
      >
        <FoldersSettingsPanel />
      </Suspense>
    </AffineErrorBoundary>
  );
};
